import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import styled from 'styled-components';
import { useDeviceCommand } from '../../hooks/useDeviceCommand';
import { faultResetPayload } from '../../helpers/payloads/faultResetPayload';
import { showsForceButton } from '../../helpers/faultRules';

import {
  handleAttendButtonClick,
  handleDisplayForceSelectionBox,
  handleFaultsReset,
  handleForceButtonClick,
  selectFaults,
} from '../store/slices/FaultsSlice';
import { justifyContentFlexEnd } from '../styles/commonStyles';

import FaultsDetailButton from './FaultsDetailButton';

const FaultsDetailButtonContainer = ({
  name,
  location,
  specificLocation,
  machine,
  faultType,
  faultNumber,
  column,
}) => {
  const isMobile = useMediaQuery({ query: '(max-width:600px)' });

  const faultsState = useSelector(selectFaults);
  const verifiedFaultsState = specificLocation
    ? faultsState[name][location][specificLocation][machine]
    : faultsState[name][location][machine];
  const { activatedResetButton } = verifiedFaultsState;

  const buttonNames = isMobile
    ? ['expand']
    : name === 'tgs'
    ? ['reset', 'attend']
    : ['force', 'reset', 'attend'];
  const dispatch = useDispatch();
  const sendCommand = useDeviceCommand(name, machine);

  const handleButtonClick = (buttonName, setResetBtnActivated) => {
    switch (buttonName) {
      case 'force':
        dispatch(
          handleForceButtonClick({
            swtName: name,
            specificLocation,
            location,
            machine,
            state: true,
          })
        );
        dispatch(
          handleDisplayForceSelectionBox({
            swtName: name,
            location,
            specificLocation,
            machine,
            state: true,
          })
        );

        break;
      case 'reset': {
        setResetBtnActivated(true);
        const payload = faultResetPayload(name, faultType, faultNumber);
        if (payload) {
          sendCommand(payload);
        }
        dispatch(
          handleFaultsReset({
            swtName: name,
            location,
            specificLocation,
            machine,
            faultType,
            faultNumber,
          })
        );
        break;
      }
      case 'attend':
        dispatch(
          handleAttendButtonClick({
            swtName: name,
            location,
            specificLocation,
            machine,
            faultType,
            state: true,
            column: column,
          })
        );
        break;
      default:
        throw new Error('unknown error', buttonName);
        break;
    }
  };

  return (
    <Wrapper>
      {buttonNames.map((title, index) => (
        <FaultsDetailButton
          name={name}
          title={title}
          showsForce={showsForceButton(faultType)}
          faultType={faultType}
          handleButtonClick={handleButtonClick}
          key={`${index}${column} ${faultNumber}`}
          buttonNum={isMobile ? 2 : index}
          location={location}
          specificLocation={specificLocation}
          machine={machine}
          faultId={faultNumber - 1}
        />
      ))}
    </Wrapper>
  );
};

export default FaultsDetailButtonContainer;

const Wrapper = styled.div`
  ${justifyContentFlexEnd};
`;
